(function() {
  'use strict';

  // Early exit for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    document.body.classList.add('page-loaded');
    return;
  }

  let isPageLoaded = false;
  let fadeTimeout = null;

  function showPage() {
    if (isPageLoaded) return;
    isPageLoaded = true;

    // Clear any pending timeout
    if (fadeTimeout) {
      clearTimeout(fadeTimeout);
      fadeTimeout = null;
    }

    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(() => {
      document.body.classList.add('page-loaded');

      // Dispatch event for other components
      document.dispatchEvent(new CustomEvent('page:fadeIn'));

      // Clean up will-change after animation
      setTimeout(() => {
        document.body.style.willChange = 'auto';
      }, 1000);
    });
  }

  function initPageFade() {
    // Immediate show if already complete
    if (document.readyState === 'complete') {
      fadeTimeout = setTimeout(showPage, 50);
      return;
    }

    // Listen for load event
    const handleLoad = () => {
      window.removeEventListener('load', handleLoad);
      fadeTimeout = setTimeout(showPage, 50);
    };

    window.addEventListener('load', handleLoad, { passive: true });

    // Fallback timeout (3 seconds max)
    setTimeout(showPage, 3000);
  }

  // Handle navigation transitions
  function handlePageTransition() {
    if (prefersReducedMotion) return;

    // Reset state
    document.body.classList.remove('page-loaded');
    document.body.style.willChange = 'opacity';
    isPageLoaded = false;

    // Re-initialize
    setTimeout(initPageFade, 50);
  }

  // Initialize based on current state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageFade, { passive: true });
  } else {
    initPageFade();
  }

  // Handle browser navigation
  window.addEventListener('popstate', handlePageTransition, { passive: true });

  // Handle programmatic navigation
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(history, arguments);
    setTimeout(handlePageTransition, 10);
  };

  history.replaceState = function() {
    originalReplaceState.apply(history, arguments);
    setTimeout(handlePageTransition, 10);
  };

  // Public API
  window.PageFade = {
    show: showPage,
    reset: function() {
      document.body.classList.remove('page-loaded');
      document.body.style.willChange = 'opacity';
      isPageLoaded = false;
    },
    isLoaded: () => isPageLoaded
  };

})();
